import * as TYPE from '../util/types'
import axios from 'axios'
import Vue from 'vue'

const state = {
	notification_text: 'This is a notification',
	notification_active: false,
	notification_link_route: '',
	notifications: []
}

const mutations = {
	[TYPE.SET_NOTIFICATION_TEXT]: (state, value) => {
		state.notification_text = value
	},
	[TYPE.SET_NOTIFICATION_ACTIVE]: (state, value) => {
		state.notification_active = value
	},
	[TYPE.SET_NOTIFICATION_LINK_ROUTE]: (state, value) => {
		state.notification_link_route = value
	},
	[TYPE.SET_NOTIFICATIONS]: (state, payload) => {
		state.notifications = payload
	},
	[TYPE.SET_NOTIFICATION_READ]: (state, payload) => {
		let index = state.notifications.indexOf(state.notifications.find((obj) => {
			return obj.pk === payload.pk
		}))
		Vue.set(state.notifications[index], 'read', true)
	}
}

const actions = {
	setNotifications({ commit }, payload) {
		commit(TYPE.SET_NOTIFICATIONS, payload)
	},
	setNotificationRead({ commit }, payload) {
		commit(TYPE.SET_NOTIFICATION_READ, payload)
	},
	setNotificationActive({ commit }, value) {
		commit(TYPE.SET_NOTIFICATION_ACTIVE, value)
	},
	setNotificationLinkRoute({ commit }, value) {
		commit(TYPE.SET_NOTIFICATION_LINK_ROUTE, value)
	},
	visitNotificationLink({ commit }) {
		// router.push(state.notification_link_route)
		console.log('link visited')
		commit(TYPE.SET_NOTIFICATION_LINK_ROUTE, '')
		commit(TYPE.SET_NOTIFICATION_ACTIVE, false)
	},
	unsubscribeUserFromPush({ commit }) {
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker.ready.then((reg) => {
				reg.pushManager.getSubscription().then((sub) => {
					sub.unsubscribe().then(function(success) {
						console.log('unsubscribed')
					}).catch(function(e) {
						console.log('unsubscription failed', e)
					});
				}).catch((e) => {
					console.log('cant get subscription', e)
				})
			})
		}
	},
	subscribeUserToPush({ commit, getters }) {
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker.ready.then((reg) => {
				reg.pushManager.getSubscription().then((sub) => {
					console.log('subscribing')
					console.log(sub)
					if (sub === null) {
						console.log('sub is null')
						console.log(reg)
						console.log(reg.pushManager)
						reg.pushManager.subscribe({
							userVisibleOnly: true
						}).then((sub) => {
							console.log('subscribed')
							console.log(sub)
							let browser = ''
							if (sub.endpoint.includes('googleapis')) {
								browser = 'chrome'
							} else if (sub.endpoint.includes('mozilla')) {
								browser = 'firefox'
							}
							let data = {
								user: getters.user.pk,
								endpoint: sub.endpoint,
								auth: sub.toJSON().keys.auth,
								key: sub.toJSON().keys.p256dh,
								browser: browser
							}
							console.log(data)
							axios.post('/api/v1/notifications/push-credentials/', data).then((result) => {
								console.log(result)
							})
						}).catch((e) => {
							console.log(e)
							if (Notification.permission === 'denied') {
								console.warn('Permission for notifications was denied');
							} else {
								console.error('Unable to subscribe to push', e);
							}
						})
					} else {
						console.log('user already subscribed')
					}
				}).catch((e) => {
					console.error(e)
				})
			}).catch((error) => {
				console.error('error checking service worker: ', error)
			})
		} else {
			console.log('no serviceWorker in navigator', navigator)
		}
	}
}

const getters = {
	getNotifications: state => {
		return state.notifications
	},
	getNotificationText: state => {
		return state.notification_text
	},
	getNotificationActive: state => {
		return state.notification_active
	},
	getNotificationLinkRoute: state => {
		return state.notification_link_route
	}
}

export default {
	state,
	getters,
	mutations,
	actions
}
